import styled from 'styled-components';
import rgba from 'polished/lib/color/rgba';
import { Dropdown } from '@zendeskgarden/react-dropdowns';
import {
  colorGrayDarkest,
  breakpointTablet,
  DEFAULT_SIZE,
} from 'components/GlobalStyles/variables';

export const FeedWrapper = styled.div`
  .header {
    display: flex;
    justify-content: space-between;

    h2 {
      font-size: 16px;
      line-height: 22px;
      letter-spacing: 0.15px;
      margin: 0;

      @media (min-width: ${breakpointTablet}px) {
        font-size: 20px;
        line-height: 27px;
      }
    }
  }
`;

export const Separator = styled.hr`
  margin: 11px -16px 0;

  opacity: 0.12;
`;

export const FeedContainer = styled.div`
  display: flex;
  flex-direction: row;
  overflow: auto;
  padding-top: 10px;

  .scheduling-feed-sidebar {
    position: sticky;
    top: 0;
    width: 231px;
    margin-right: 40px;

    &:after {
      content: '';
      position: absolute;
      height: 100%;
      right: 0;
      width: 1px;
      background-color: ${rgba(colorGrayDarkest, 0.12)};
      top: -1rem;
    }

    ul,
    li {
      margin: 0;
      padding: 0;
    }

    li {
      display: block;
      margin-bottom: ${DEFAULT_SIZE * 2}px;

      button {
        cursor: pointer;
        border: 0;
        background: none;
        font-size: 13px;
        line-height: 16px;
        letter-spacing: 0.75px;
        color: ${rgba(colorGrayDarkest, 0.54)};

        &:focus {
          outline: 0 none;
        }
      }

      &.active {
        button {
          color: ${colorGrayDarkest};
        }
      }
    }
  }

  .scheduling-feed-elements {
    flex: 1;
    min-width: 255px;
    overflow-y: auto;
  }
`;

export const SelectBox = styled(Dropdown)`
  border: 0 none !important;
  font-size: 12px !important;
  line-height: 22px !important;
  cursor: pointer !important;
  min-height: 32px !important;
`;
